import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UserService} from '../../services/user.service';
import {SnackBarService} from '../../services/snack-bar.service';

@Component({
  selector: 'app-reminder-set-mobile',
  templateUrl: './reminder-set-mobile.component.html',
  styleUrls: ['./reminder-set-mobile.component.css']
})
export class ReminderSetMobileComponent implements OnInit {
  public user = {
    mobile: ''
  };
  constructor(public dialogRef: MatDialogRef<ReminderSetMobileComponent>,
              public userService: UserService,
              private snackbarService: SnackBarService) { }

  ngOnInit(): void {
  }
  closeDialog(): any{
    this.dialogRef.close();
  }
  addPhoneNumber(): any{
    this.userService.updateProfile(this.user).subscribe(
      (data) => {
        this.snackbarService.showSnackBar('شماره موبایل شما با موفقیت ثبت شد.', 'green-snackbar');
        this.closeDialog();
      }, (error) => {
        this.snackbarService.showSnackBar(error.error.mobile[0], 'red-snackbar');
      }
    );
  }
}
